import { useParams } from "react-router";
import { useRltOfferShowQuery } from "@/services/backend/rlt/offers/api/offer-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { CalculationComponent } from "@/routes/processes/[processId]/rlt/calculations/[calculationId]/calculation/calculation-route";

export function OfferCalculationRoute() {
  const { offerId } = useParams();
  const {
    data: offer,
    isLoading,
    error,
  } = useRltOfferShowQuery({ id: offerId! });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return null;
  }

  return (
    <CalculationComponent
      calculationId={offer!.calculationId}
      disabled={offer!.immutable}
    />
  );
}
